<div class="register-container">
  <div class="register-card" [class.validation-error]="showValidationAnimation">
    <div class="register-header">
      <div class="header-content">
        <div class="header-text">
          <h2>{{ t('createAccount') }}</h2>
          <p class="register-description">{{ t('joinUsDescription') }}</p>
        </div>
          <div class="language-section">
            <app-language-selector></app-language-selector>
          </div>
        </div>
    </div>

    <div class="register-form">
      <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" class="needs-validation" novalidate autocomplete="off">
        <!-- Personal Information - Name and Email in same row -->
        <div class="form-grid">
            <div class="form-group">
            <label for="name" class="form-label">
              <i class="fas fa-user label-icon"></i>
              <span>{{ t('name') }}</span>
            </label>
              <div class="input-wrapper">
                <input id="name" formControlName="name" type="text" [placeholder]="t('enterFullName')"
                class="form-input" [class.error]="name?.invalid && (name?.dirty || name?.touched)"
                [class.valid]="name?.valid && name?.dirty" autocomplete="off">
              </div>
              <div *ngIf="name?.invalid && (name?.dirty || name?.touched)" class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="name?.errors?.['required']">{{ t('nameRequired') }}</span>
              <span *ngIf="name?.errors?.['minlength']">{{ t('nameMinLength') }}</span>
            </div>
          </div>
            <div class="form-group">
            <label for="email" class="form-label">
              <i class="fas fa-envelope label-icon"></i>
              <span>{{ t('email') }}</span>
            </label>
              <div class="input-wrapper">
                <input id="email" formControlName="email" type="email" [placeholder]="t('enterEmail')"
                class="form-input" [class.error]="email?.invalid && (email?.dirty || email?.touched)"
                [class.valid]="email?.valid && email?.dirty" autocomplete="off">
              </div>
              <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="email?.errors?.['required']">{{ t('emailRequired') }}</span>
              <span *ngIf="email?.errors?.['email']">{{ t('validEmail') }}</span>
              <span *ngIf="email?.errors?.['emailExists']">{{ t('emailExists') }}</span>
            </div>
          </div>
            <div class="form-group">
            <label for="mobile" class="form-label">
              <i class="fas fa-mobile-alt label-icon"></i>
              <span>{{ t('mobileNumber') }}</span>
            </label>
              <div class="input-wrapper">
                <input id="mobile" formControlName="mobile" type="text" [placeholder]="t('enterMobileNumber')"
                class="form-input" [class.error]="mobile?.invalid && (mobile?.dirty || mobile?.touched)"
                [class.valid]="mobile?.valid && mobile?.dirty" autocomplete="off">
              </div>
              <div *ngIf="mobile?.invalid && (mobile?.dirty || mobile?.touched)" class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="mobile?.errors?.['required']">{{ t('mobileRequired') }}</span>
              <span *ngIf="mobile?.errors?.['pattern']">{{ t('validMobile') }}</span>
              <span *ngIf="mobile?.errors?.['mobileExists']">{{ t('mobileExists') }}</span>
            </div>
          </div>
            <div class="form-group">
            <label for="altMobile" class="form-label">
              <i class="fas fa-mobile-alt label-icon"></i>
              <span>{{ t('altMobile') }}</span>
            </label>
              <div class="input-wrapper">
                <input id="altMobile" formControlName="altMobile" type="text" [placeholder]="t('alternateMobileNumber')"
                class="form-input" [class.error]="altMobile?.invalid && (altMobile?.dirty || altMobile?.touched)"
                [class.valid]="altMobile?.valid && altMobile?.dirty" autocomplete="off">
              </div>
              <div *ngIf="altMobile?.invalid && (altMobile?.dirty || altMobile?.touched)" class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="altMobile?.errors?.['pattern']">{{ t('validAltMobile') }}</span>
            </div>
          </div>
            <div class="form-group">
            <label for="password" class="form-label">
              <i class="fas fa-lock label-icon"></i>
              <span>{{ t('password') }}</span>
            </label>
              <div class="input-wrapper">
                <input id="password" formControlName="password" type="password" [placeholder]="t('createPassword')"
                class="form-input" [class.error]="password?.invalid && (password?.dirty || password?.touched)"
                [class.valid]="password?.valid && password?.dirty" autocomplete="new-password">
              </div>
              <div *ngIf="password?.invalid && (password?.dirty || password?.touched)" class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="password?.errors?.['required']">{{ t('passwordRequired') }}</span>
              <span *ngIf="password?.errors?.['minlength']">{{ t('passwordMinLength') }}</span>
            </div>
          </div>
            <div class="form-group">
            <label for="confirmPassword" class="form-label">
              <i class="fas fa-lock label-icon"></i>
              <span>{{ t('confirmPassword') }}</span>
            </label>
              <div class="input-wrapper">
                <input id="confirmPassword" formControlName="confirmPassword" type="password"
                  [placeholder]="t('confirmYourPassword')" class="form-input"
                [class.error]="confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)"
                [class.valid]="confirmPassword?.valid && confirmPassword?.dirty" autocomplete="new-password">
              </div>
              <div *ngIf="confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)"
                class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="confirmPassword?.errors?.['required']">{{ t('confirmPasswordRequired') }}</span>
              <span *ngIf="confirmPassword?.errors?.['mismatch']">{{ t('passwordsMismatch') }}</span>
            </div>
          </div>
            <div class="form-group">
            <label for="gender" class="form-label">
              <i class="fas fa-venus-mars label-icon"></i>
              <span>{{ t('gender') }}</span>
            </label>
              <div class="input-wrapper">
                <select id="gender" formControlName="gender" class="form-input"
                [class.error]="gender?.invalid && (gender?.dirty || gender?.touched)"
                [class.valid]="gender?.valid && gender?.dirty" autocomplete="off">
                  <option value="">{{ t('selectGender') }}</option>
                  <option value="male">{{ t('male') }}</option>
                  <option value="female">{{ t('female') }}</option>
                  <option value="other">{{ t('other') }}</option>
                </select>
              </div>
              <div *ngIf="gender?.invalid && (gender?.dirty || gender?.touched)" class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="gender?.errors?.['required']">{{ t('genderRequired') }}</span>
            </div>
          </div>
            <div class="form-group">
            <label for="dateOfBirth" class="form-label">
              <i class="fas fa-calendar label-icon"></i>
              <span>{{ t('dateOfBirth') }}</span>
            </label>
              <div class="input-wrapper">
                <input id="dateOfBirth" formControlName="dateOfBirth" type="date" class="form-input"
                  [max]="maxDate" [min]="minDate" [class.error]="dateOfBirth?.invalid && (dateOfBirth?.dirty || dateOfBirth?.touched)"
                [class.valid]="dateOfBirth?.valid && dateOfBirth?.dirty"
                (focus)="openDatePicker()" autocomplete="off">
              </div>
              <div *ngIf="dateOfBirth?.invalid && (dateOfBirth?.dirty || dateOfBirth?.touched)" class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="dateOfBirth?.errors?.['required']">{{ t('dateOfBirthRequired') }}</span>
              <span *ngIf="dateOfBirth?.errors?.['minAge']">{{ t('minAgeRequired') || 'Minimum age required is 10 years.' }}</span>
            </div>
          </div>
            <div class="form-group">
            <label for="currentHeight" class="form-label">
              <i class="fas fa-ruler-vertical label-icon"></i>
              <span>{{ t('height') }}</span>
            </label>
              <div class="input-wrapper">
                <input id="currentHeight" formControlName="currentHeight" type="number" [placeholder]="t('heightInCm')"
                  class="form-input"
                [class.error]="currentHeight?.invalid && (currentHeight?.dirty || currentHeight?.touched)"
                [class.valid]="currentHeight?.valid && currentHeight?.dirty" autocomplete="off">
              </div>
              <div *ngIf="currentHeight?.invalid && (currentHeight?.dirty || currentHeight?.touched)"
                class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="currentHeight?.errors?.['required']">{{ t('heightRequired') }}</span>
              <span *ngIf="currentHeight?.errors?.['min'] || currentHeight?.errors?.['max']">{{ t('validHeight') }}</span>
            </div>
          </div>
            <div class="form-group">
            <label for="currentWeight" class="form-label">
              <i class="fas fa-weight label-icon"></i>
              <span>{{ t('currentWeight') }}</span>
            </label>
            <div class="input-wrapper">
              <input id="currentWeight" formControlName="currentWeight" type="number" [placeholder]="t('weightInKg')"
                  class="form-input"
                [class.error]="currentWeight?.invalid && (currentWeight?.dirty || currentWeight?.touched)"
                [class.valid]="currentWeight?.valid && currentWeight?.dirty" autocomplete="off">
              </div>
              <div *ngIf="currentWeight?.invalid && (currentWeight?.dirty || currentWeight?.touched)"
                class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="currentWeight?.errors?.['required']">{{ t('weightRequired') }}</span>
              <span *ngIf="currentWeight?.errors?.['min'] || currentWeight?.errors?.['max']">{{ t('validWeight') }}</span>
                </div>
              </div>
          <div class="form-group form-group-full">
            <label for="fullAddress" class="form-label">
              <i class="fas fa-map-marker-alt label-icon"></i>
              <span>{{ t('fullAddress') }}</span>
            </label>
            <div class="input-wrapper">
              <textarea id="fullAddress" formControlName="fullAddress" [placeholder]="t('enterCompleteAddress')"
                  class="form-input" rows="3"
                [class.error]="fullAddress?.invalid && (fullAddress?.dirty || fullAddress?.touched)"
                [class.valid]="fullAddress?.valid && fullAddress?.dirty" autocomplete="off"></textarea>
              </div>
              <div *ngIf="fullAddress?.invalid && (fullAddress?.dirty || fullAddress?.touched)" class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="fullAddress?.errors?.['required']">{{ t('addressRequired') }}</span>
              <span *ngIf="fullAddress?.errors?.['minlength']">{{ t('addressMinLength') }}</span>
              </div>
            </div>
          <div class="form-group form-group-full">
            <label class="form-label">
              <i class="fas fa-camera label-icon"></i>
              <span>{{ t('recentPhoto') }}</span>
            </label>
            <div class="file-upload-wrapper">
              <div class="file-upload" [class.has-preview]="photoPreview" (click)="!photoPreview && fileInput.click()">
                <input type="file" #fileInput (change)="onFileSelected($event); $event.stopPropagation()" accept="image/*" class="file-input">
                <div *ngIf="!photoPreview" class="file-upload-content">
                  <div class="file-upload-icon">
                    <i class="fas fa-cloud-upload-alt"></i>
          </div>
                  <span class="file-label">{{ t('choosePhoto') }}</span>
                  <small class="file-hint">Max size: 2 MB. JPG/PNG preferred.</small>
                </div>
                <div *ngIf="photoPreview" class="photo-preview-container">
                  <div class="photo-preview-wrapper">
                    <img [src]="photoPreview" alt="Photo preview" class="photo-preview">
                    <button type="button" (click)="removePhoto(); $event.stopPropagation()" class="remove-photo-btn">
                      <i class="fas fa-times"></i>
                  </button>
                </div>
                </div>
              </div>
              <div *ngIf="errorMessage" class="error-message file-error">
                <i class="fas fa-exclamation-circle"></i>
                <span>{{ errorMessage }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group form-group-full checkbox-group terms-and-offline-row">
          <div class="terms-block">
            <label class="checkbox-label" for="agreeTerms">
              <input type="checkbox" formControlName="agreeTerms" class="checkbox-input" id="agreeTerms" (click)="openTermsModal()">
              <span class="custom-checkbox"></span>
              <span class="checkbox-text">
                <a href="javascript:void(0)" class="terms-link" (click)="openTermsModal(); $event.preventDefault()" data-bs-toggle="modal" data-bs-target="#termsModal">{{ t('agreeTerms') }}</a>
              </span>
            </label>
            <div *ngIf="agreeTerms?.invalid && (agreeTerms?.dirty || agreeTerms?.touched)" class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="agreeTerms?.errors?.['required']">{{ t('termsRequired') || 'You must agree to the terms and conditions' }}</span>
            </div>
          </div>
          <div class="already-bought-block">
            <span class="inline-label">{{ t('alreadyBoughtDose') }}</span>
            <label class="radio-inline">
              <input type="radio" formControlName="alreadyBoughtDose" value="no" class="radio-input">
              <span>{{ t('alreadyBoughtDoseNo') }}</span>
            </label>
            <label class="radio-inline">
              <input type="radio" formControlName="alreadyBoughtDose" value="yes" class="radio-input">
              <span>{{ t('alreadyBoughtDoseYes') }}</span>
            </label>
          </div>
        </div>
        <div *ngIf="alreadyBoughtDose?.value === 'yes'" class="form-group form-group-full offline-warning">
          <div class="warning-box">
            <i class="fas fa-exclamation-triangle"></i>
            <p>{{ t('alreadyBoughtDoseWarning') }}</p>
          </div>
        </div>

        <div class="form-group form-group-full" *ngIf="!showOtpInput">
          <div class="captcha-section">
            <div class="captcha-hint">{{ t('pleaseCompleteCaptcha') || 'Please complete the reCAPTCHA first, then tap Register with OTP.' }}</div>
            <div id="recaptcha-container" class="recaptcha-container"></div>
          </div>
          <div class="button-group-primary">
            <button type="button" class="register-btn outline" (click)="navigateToLogin()">
              <i class="fas fa-arrow-left"></i>
              <span>{{ t('login') }}</span>
              </button>
            <button type="submit" class="register-btn primary" [disabled]="isLoading" [class.loading]="isLoading">
              <span *ngIf="!isLoading" class="btn-content">
                <i class="fas fa-paper-plane"></i>
                <span>{{ t('registerWithOtp') }}</span>
                </span>
              <span *ngIf="isLoading" class="btn-content">
                  <i class="fas fa-spinner fa-spin"></i>
                <span>{{ t('sendingOtp') }}</span>
                </span>
              </button>
          </div>
        </div>


        <!-- OTP Verification Section -->
        <div *ngIf="showOtpInput" class="otp-section">
          <div class="otp-header">
            <div class="otp-icon">
              <i class="fas fa-shield-alt"></i>
            </div>
            <h3>{{ t('enterOtpSentTo') }}</h3>
            <p class="otp-mobile">{{ registrationForm.value.mobile }}</p>
          </div>
          <div class="form-group">
            <label for="otp" class="form-label">
              <i class="fas fa-key label-icon"></i>
              <span>{{ t('enter6DigitOtp') }}</span>
            </label>
            <div class="input-wrapper otp-input-wrapper">
              <input id="otp" [formControl]="otpControl" type="text" [placeholder]="t('enter6DigitOtp')"
                maxlength="6" class="form-input otp-input"
                [class.error]="otpForm.get('otp')?.invalid && (otpForm.get('otp')?.touched || otpForm.get('otp')?.dirty)"
                [class.valid]="otpForm.get('otp')?.valid && otpForm.get('otp')?.dirty" autocomplete="off">
          </div>
          <div *ngIf="otpForm.get('otp')?.invalid && (otpForm.get('otp')?.touched || otpForm.get('otp')?.dirty)"
            class="error-message">
              <i class="fas fa-exclamation-circle"></i>
              <span *ngIf="otpForm.get('otp')?.errors?.['required']">{{ t('otpRequired') }}</span>
              <span *ngIf="otpForm.get('otp')?.errors?.['pattern']">{{ t('validOtp') }}</span>
          </div>
        </div>
          <div class="button-group-otp">
            <button type="submit" class="register-btn primary" [disabled]="otpForm.invalid || isLoading"
              [class.loading]="isLoading">
              <span *ngIf="!isLoading" class="btn-content">
                <i class="fas fa-check"></i>
                <span>{{ t('verifyAndRegister') }}</span>
              </span>
              <span *ngIf="isLoading" class="btn-content">
                <i class="fas fa-spinner fa-spin"></i>
                <span>{{ t('verifying') }}</span>
              </span>
            </button>
            <button type="button" class="register-btn secondary" (click)="goBack()" [disabled]="isLoading">
              <i class="fas fa-arrow-left"></i>
              <span>{{ t('changeNumber') }}</span>
            </button>
          </div>
        </div>

        <div class="success-message" *ngIf="successMessage">
          <i class="fas fa-check-circle"></i>
          <span>{{ successMessage }}</span>
        </div>
      </form>


    </div>
  </div>
</div>

<!-- Terms and Conditions Modal -->
<div class="modal fade" id="termsModal" tabindex="-1" aria-labelledby="termsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="termsModalLabel">{{ t('termsAndConditions') }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>{{ t('termsIntro') || 'Please read these Terms and Conditions carefully before registering.' }}</strong></p>
        <ol class="ps-3">
          <li>{{ t('termsPoint1') || 'You agree to provide accurate information and keep it updated.' }}</li>
          <li>{{ t('termsPoint2') || 'Your data may be used to provide and improve our services.' }}</li>
          <li>{{ t('termsPoint3') || 'You consent to receive account and transactional communications.' }}</li>
          <li>{{ t('termsPoint4') || 'Unauthorized use of the service is prohibited.' }}</li>
          <li>{{ t('termsPoint5') || 'All purchases are subject to our refund and shipping policies.' }}</li>
          <li>{{ t('termsPoint6') || 'All personal and medical information will be kept confidential.' }}</li>
          <li>{{ t('termsPoint7') || 'We cannot guarantee treatment duration, results timeline, or intensity.' }}</li>
          <li>{{ t('termsPoint8') || 'Doctors provide guidance only; final decision is patient responsibility.' }}</li>
        </ol>
        <p class="text-muted mb-0">{{ t('termsFooter') || 'If you do not agree to these terms, please do not proceed with registration.' }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ t('close') || 'Close' }}</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">{{ t('iAgree') || 'I Agree' }}</button>
      </div>
    </div>
  </div>
  <!-- More modals/components may follow -->
</div>

<app-offline-purchase-modal
  *ngIf="showOfflineModal"
  (confirm)="onOfflineModalConfirm($event)"
  (cancel)="onOfflineModalCancel()">
</app-offline-purchase-modal>